import { get } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuAPIInvoices {
    //This method returns all invoices associated with a customer
    getAllInvoices() {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/invoices",
        })));
    }
    //This method returns a draft of the upcoming invoice for this billing cycle
    getUpcomingInvoice() {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/invoices/upcoming",
        })));
    }
}
//# sourceMappingURL=velavu-api-invoices.js.map